export default "__VITE_ASSET__bd3e0864__"